import styled from "@emotion/styled";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Popper from "@mui/material/Popper";
import { SwipeableDrawer } from "src/components/Default/LekUI/SwipableDrawer";
import isMobile from "src/helpers/isMobile";

function LUIPopper({ anchorEl, children, className }) {
	return (
		<Popper
			open={!!anchorEl}
			anchorEl={anchorEl}
			placement="bottom-end"
			className={className}
		>
			{children}
		</Popper>
	);
}

export default styled(LUIPopper)`
  z-index: 9;
  max-width: 400px;
  min-width: 230px;
`;

export const SwipeablePopper = ({
	anchorEl,
	children,
	handleClose,
	isOpen,
}) => {
	if (isMobile()) {
		return (
			<SwipeableDrawer open={!!isOpen} onClose={handleClose}>
				{children}
			</SwipeableDrawer>
		);
	}

	return (
		<ClickAwayListener onClickAway={handleClose}>
			<Popper
				open={isOpen}
				anchorEl={anchorEl}
				placement="bottom-start"
				className="popper p-12"
			>
				{children}
			</Popper>
		</ClickAwayListener>
	);
};
